import { render, staticRenderFns } from "./ListaPerfis.vue?vue&type=template&id=b98b8524&scoped=true"
import script from "./ListaPerfis.vue?vue&type=script&lang=js"
export * from "./ListaPerfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98b8524",
  null
  
)

export default component.exports